export interface IColor {
  lightGrey: string;
  osloGray: string;
  gray: string;
  white: string;
  dirtyWhite: string;
  red: string;
  cornflowerBlue: string;
  alto: string;
  black: string;
  primaryTextColor: string;
  snowColor: string;
  gallery: string;
  hitGray: string;
  grey300: string;
  shadowGrey: string;
  coldPurple: string;
  mineShaft: string;
  lightPurple: string;
  extraLight: string;

  whiteWithOpacity: (opacity: number) => string;
  purple: (alpha: number) => string;
  cornflowerBlueWithOpacity: (opacity: number) => string;
  transparentPrimary: string;
  transparent: string;
  cornflowerBlueLight: string;
  titanWhite: string;
  pickledBluewood: string;
  carnation: string;
  mischka: string;
  silverChalice: string;
  shadowColor: string;
  manatee: string;
  alabaster: string;
  orangePeel: string;
  barleyWhite: string;
  cinderella: string;
  blackSqueeze: string;
  lynch: string;
  narvik: string;
  emerald: string;
  athensGrey: string;
  lavenderWeb: string;
  heliotrope: string;
  romanSilver: string;
  slateGray: string;
  violetBlue: string;
  seashell: string;
  rust: string;
}

export const light = {
  lightGrey: 'rgba(238, 238, 238, 0.7)',
  white: 'rgba(255, 255, 255, 1)',
  dirtyWhite: 'rgba(250, 250, 250, 1)',
  red: 'rgba(242, 101, 99, 1)',
  alto: 'rgba(224, 224, 224, 1)',
  black: '#000000',
  osloGray: '#80868B',
  gray: '#7E7E7E',
  grey: '#80868B',
  primaryTextColor: 'rgba(16, 24, 40, 1)',
  snowColor: 'rgba(255, 250, 250, 1)',
  grey300: 'rgba(208, 213, 221, 1)',
  cornflowerBlue: 'rgba(118, 96, 251, 1)',
  gallery: 'rgba(240, 240, 240, 1)',
  hitGray: '#ADB5BD',
  shadowGrey: 'rgba(164, 162, 162, 0.25)',
  coldPurple: 'rgba(168, 175, 227, 1)',
  lightPurple: 'rgba(241, 239, 255, 1)',
  titanWhite: 'rgba(232, 228, 255, 1)',
  pickledBluewood: '#344563',
  carnation: 'rgba(242, 101, 99, 1)',
  mineShaft: 'rgba(31, 31, 31, 1)',
  transparent: 'transparent',
  extraLight: 'rgba(224, 226, 247, 1)',
  romanSilver: 'rgba(134, 144, 156, 1)',

  cornflowerBlueWithOpacity: (opacity: number) =>
    `rgba(118, 96, 251, ${opacity})`,
  whiteWithOpacity: (opacity: number) => `rgba(255, 255, 255, ${opacity})`,
  purple: (alpha: number) => `rgba(146, 128, 255, ${alpha})`,
  transparentPrimary: 'rgba(0, 0, 0, 0.25)',
  cornflowerBlueLight: 'rgba(118, 96, 251, 0.13)',
  mischka: 'rgba(214, 213, 218, 1)',
  silverChalice: 'rgba(158,158, 158, 1)',
  shadowColor: 'rgba(233, 237, 247, 0.55)',
  manatee: 'rgba(147, 147, 170, 1)',
  alabaster: 'rgba(249, 249, 249, 1)',
  orangePeel: 'rgba(255, 153, 0, 1)',
  barleyWhite: 'rgba(255, 243, 202, 1)',
  cinderella: 'rgba(253, 232, 231, 1)',
  blackSqueeze: 'rgba(240, 245, 249, 1)',
  lynch: 'rgba(97, 117, 138, 1)',
  narvik: 'rgba(232, 247,238, 1)',
  emerald: 'rgba(66,214,120, 1)',
  athensGrey: 'rgba(231,231,237, 1)',
  lavenderWeb: '#EDEAFF',
  heliotrope: 'rgba(142, 123, 255, 1)',
  slateGray: '#667085',
  violetBlue: '#7A6FC8',
  seashell: '#FFF6ED',
  rust: '#C4320A',
};

export const dark = {
  lightGrey: 'rgba(238, 238, 238, 0.7)',
  white: 'rgba(255, 255, 255, 1)',
  dirtyWhite: 'rgba(250, 250, 250, 1)',
  red: 'rgba(242, 101, 99, 1)',
  gray: '#7E7E7E',
  alto: 'rgba(224, 224, 224, 1)',
  black: '#000000',
  osloGray: '#80868B',
  grey: '#80868B',
  primaryTextColor: 'rgba(16, 24, 40, 1)',
  snowColor: 'rgba(255, 250, 250, 1)',
  grey300: 'rgba(208, 213, 221, 1)',
  cornflowerBlue: 'rgba(118, 96, 251, 1)',
  gallery: 'rgba(240, 240, 240, 1)',
  hitGray: '#ADB5BD',
  shadowGrey: 'rgba(164, 162, 162, 0.25)',
  coldPurple: 'rgba(168, 175, 227, 1)',
  lightPurple: 'rgba(241, 239, 255, 1)',
  titanWhite: 'rgba(232, 228, 255, 1)',
  pickledBluewood: '#344563',
  carnation: 'rgba(242, 101, 99, 1)',
  mineShaft: 'rgba(31, 31, 31, 1)',
  transparent: 'transparent',
  extraLight: 'rgba(224, 226, 247, 1)',
  romanSilver: 'rgba(134, 144, 156, 1)',


  cornflowerBlueWithOpacity: (opacity: number) =>
    `rgba(118, 96, 251, ${opacity})`,
  whiteWithOpacity: (opacity: number) => `rgba(255, 255, 255, ${opacity})`,
  purple: (alpha: number) => `rgba(146, 128, 255, ${alpha})`,
  transparentPrimary: 'rgba(0, 0, 0, 0.25)',
  cornflowerBlueLight: 'rgba(118, 96, 251, 0.13)',
  mischka: 'rgba(214, 213, 218, 1)',
  silverChalice: 'rgba(158,158, 158, 1)',
  shadowColor: 'rgba(233, 237, 247, 0.55)',
  manatee: 'rgba(147, 147, 170, 1)',
  alabaster: 'rgba(249, 249, 249, 1)',
  orangePeel: 'rgba(255, 153, 0, 1)',
  barleyWhite: 'rgba(255, 243, 202, 1)',
  cinderella: 'rgba(253, 232, 231, 1)',
  blackSqueeze: 'rgba(240, 245, 249, 1)',
  lynch: 'rgba(97, 117, 138, 1)',
  narvik: 'rgba(232, 247,238, 1)',
  emerald: 'rgba(66,214,120, 1)',
  athensGrey: 'rgba(231,231,237, 1)',
  lavenderWeb: '#EDEAFF',
  heliotrope: 'rgba(142, 123, 255, 1)',
  slateGray: '#667085',
  violetBlue: '#7A6FC8',
  seashell: '#FFF6ED',
  rust: '#C4320A',
};
